import React from 'react';
import WmsScreenSetup from '../components/WmsScreenSetup';
import { useTranslation } from 'react-i18next';

const WmsPickingSetup: React.FC = () => {
  const { t } = useTranslation('warehouse');
  return <WmsScreenSetup screenType="picking" title={t('pages.reports.pickingScreenSettingsTitle')} />;
};

export default WmsPickingSetup;
